const apiGet = async (args) => {
  const { url, query = {}, debug = false } = args;

  const urlParams = new URLSearchParams(query);

  if (urlParams.has("id")) {
    url = `${url}/${urlParams.get("id")}`;
    urlParams.delete("id");
  }

  const urlQuery = urlParams.toString();
  const urlWithQuery = url + (urlQuery ? `?${urlQuery}` : "");

  const response = await fetch(urlWithQuery, {
    method: "GET",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-WP-Nonce": rafa_react_components?.nonce,
    },
  });

  const result = {
    headers: Object.fromEntries(response.headers.entries()),
    data: await response.json(),
  };

  if (result.code) {
    throw result;
  }

  if (debug) {
    console.groupCollapsed("%capiGet DEBUG -> %s", "font-size: 14px;", url);
    console.trace();
    console.log("%cargs -> %O", "font-size: 14px;", args);
    console.log("%cresult -> %O", "font-size: 14px;", result);
    console.groupEnd();
  }

  return result;
};

export default apiGet;
